module.exports = __webpack_public_path__ + "static/media/logo_crevisc.4acb5a75.svg";